module.exports = "<body>\n</body>\n"